import React, {useContext, useEffect, useMemo} from 'react';
import { PaymentContext, PaymentMode, PaymentInfoContext } from '../../App';
import Button from '@material-ui/core/Button';
import Lock from '../../assets/svg/secr-lock.svg';
import useStyles from './styles';
import { useTranslation } from 'react-i18next';
import { CurrencyFormats, PaymentModes, zeroDecimalCurrency } from '../../utils/index';
import { Typography } from "@material-ui/core";

const Buttons = ({ formik, currencyList, warningMessage }) => {
  const classes = useStyles();
  const paymentMode = useContext(PaymentMode);
  const payment = useContext(PaymentContext);
  const paymentInfo = useContext(PaymentInfoContext);
  const { t } = useTranslation();

  const getPrice = useMemo(() => {
    if (formik?.values?.isFullOrderAmountPaid) return formik?.values?.amount;
    const scheduled = formik?.values?.paymentSchedule?.filter(x => x.status !== "Paid");
    return scheduled && scheduled.length ? scheduled[0]?.amountInOrderCurrency : formik?.values?.amount;
  }, [formik]);

  const getPayment = useMemo(() => {
    if (
      paymentMode === PaymentModes.Token ||
      (paymentMode === PaymentModes.PayLater && !formik?.values?.isFullOrderAmountPaid)
    ) {
      return t('Save_Card');
    }    
    const precision = zeroDecimalCurrency(currencyList?.find(x => x.iso === formik?.values?.currency) ?? { decimals: paymentInfo?.currencyDecimals }) ? 0 : 2;
    return `${paymentMode === PaymentModes.Authorize ? t('Authorize_Card'): t('PAY')} ${formik?.values?.currency} ${CurrencyFormats(parseFloat(getPrice).toFixed(precision), precision)}`;
  }, [paymentMode, formik?.values?.currency, getPrice, currencyList]);

  useEffect(() => {
    if (
        paymentMode === PaymentModes.Token ||
        (paymentMode === PaymentModes.PayLater && !formik?.values?.isFullOrderAmountPaid)
    ) {
      formik.setFieldValue('saveCard', true);
    }
  }, [paymentMode, formik?.values?.currency, getPrice, currencyList]);

  return (
    !payment && (
      <>
        {
          !!warningMessage && (
            <Typography align="center" className={classes.error} gutterBottom>
              { warningMessage }
            </Typography>
          )
        }
        <div className={classes.buttonContainer}>
          <Button
            fullWidth
            variant="contained"
            color="secondary"
            size="large"
            disabled={!(formik.isValid && formik.dirty)}
            type="submit">
            {getPayment}
          </Button>
        </div>
        <div className={`${classes.terms} policy_text`}>
          <div className={`${classes.secure} policy_text`}>
            <i>
              <img className={classes.lock} src={Lock} alt="secr-lock" />
            </i>{' '}
            {t('scure_transmision_msg')}
          </div>
          <div className={`${classes.info} policy_text`}>
            {t('payment_processed_partner_msg')}{' '}
            <a target="_blank" rel="noreferrer" href="https://www.iolpay.com/terms.html">
              {t('term_conditions')}
            </a>
            .
          </div>
        </div>
      </>
    )
  );
};

export default Buttons;
